module.exports = __webpack_public_path__ + "home/img/media.8aaa4f2c.svg";